<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Choose organisation</ion-title>
        <ion-buttons slot="end" *ngIf="!organisation">
            <ion-button *ngIf="!hide_add_organisation_button" (click)="presentAddOrganisationModal()">
                <fa-icon [icon]="['far', 'plus']" size="lg" [fixedWidth]="true" slot="end"></fa-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <ion-toolbar *ngIf="!organisation">
        <ion-searchbar #search_bar_input placeholder="Search for an organisation" debounce="200" [(ngModel)]="keywords" (ionInput)="searchOrganisations()"></ion-searchbar>
    </ion-toolbar>

</ion-header>

<ion-content>

    <div *ngIf="organisation">
        <ion-item lines="full">
            <ion-label>{{organisation.title}}</ion-label>
            <fa-icon [icon]="['fal', 'times']" size="lg" (click)="clear()" slot="end"></fa-icon>
        </ion-item>
    </div>

    <div *ngIf="!organisation">
        <ion-list *ngIf="visible_organisations && visible_organisations.length != 0">
            <ion-item *ngFor="let organisation of visible_organisations" lines="full" button="true" (click)="select(organisation.id)">
                <ion-label *ngIf="organisation.title">{{organisation.title}}</ion-label>
            </ion-item>
        </ion-list>
        <ion-infinite-scroll *ngIf="visible_organisations && visible_organisations.length != 0" threshold="100px" (ionInfinite)="showMoreVisibleOrganisations($event)">
            <ion-infinite-scroll-content loadingSpinner="crescent" loadingText="Loading"></ion-infinite-scroll-content>
        </ion-infinite-scroll>
    </div>

    <ion-grid *ngIf="visible_organisations && visible_organisations.length == 0" class="nothing-found">
        <ion-row class="ion-align-items-center ion-justify-content-center">
            <ion-col>
                <p>
                    <fa-icon [icon]="['fal', 'building']" size="6x"></fa-icon>
                    <span>No organisations found</span>
                </p>
            </ion-col>
        </ion-row>
    </ion-grid>
    
</ion-content>

